<template>
  <div class="user-info-container">
    <div class="content">
      <div class="setting-item">
        <div class="title" @click="logData">邮件偏好</div>
        <div class="items email">
          <div class="item">
            <div class="label">
              <div class="email-switch-pc">
                <div class="kuang" @click="changeState(1)">
                  <img
                    class="img"
                    src="../assets/image/icon/close.svg"
                    v-if="formData.subscribePreference"
                  />
                </div>
              </div>
              <!--              <i-switch-->
              <!--                class="email-switch-mb"-->
              <!--                true-color="#84c381"-->
              <!--                false-color="#8e8f8b"-->
              <!--                v-model="subscribePreference"-->
              <!--              />-->
            </div>
            <div class="value">THOM BROWNE 电子报</div>
          </div>
        </div>
      </div>
      <div class="setting-item">
        <div class="title shop">购物偏好设置</div>
        <div class="items">
          <div class="item">
            <div class="label">
              <div class="email-switch-pc">
                <div class="kuang" @click="changeState(2)">
                  <img class="img" src="../assets/image/icon/close.svg" v-if="ladyWear" />
                </div>
              </div>
              <!--              <i-switch-->
              <!--                class="email-switch-mb"-->
              <!--                true-color="#84c381"-->
              <!--                false-color="#8e8f8b"-->
              <!--                v-model="womenWear"-->
              <!--              />-->
            </div>
            <div class="value">女装</div>
          </div>
          <div class="item">
            <div class="label">
              <div class="email-switch-pc">
                <div class="kuang" @click="changeState(3)">
                  <img class="img" src="../assets/image/icon/close.svg" v-if="manWear" />
                </div>
              </div>
              <!--              <i-switch-->
              <!--                class="email-switch-mb"-->
              <!--                true-color="#84c381"-->
              <!--                false-color="#8e8f8b"-->
              <!--                v-model="manWear"-->
              <!--              />-->
            </div>
            <div class="value">男装</div>
          </div>
        </div>
      </div>
      <div class="action">
        <div class="action-tip" v-if="actionTip==1">您已成功订阅</div>
        <div class="action-tip" v-if="actionTip==2">您已取消订阅</div>
        <div class="save-btn1 btn" @click="save" :class="changeBtnBg()">
          <div>保存偏好设置</div>
          <img class="icon" src="../assets/image/icon/shop-cart-right.svg" v-if="actionBtnType==0" />
          <img
            class="icon"
            src="../assets/image/icon/shop-cart-right-grey.png"
            v-if="actionBtnType==1"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserInfo",
  data() {
    return {
      originalData:"",
      formData: {
        shoppingPreference: [],
        subscribePreference: false,
      },
      actionBtnType: 2,
      actionTip: 0,
      manWear: false,
      ladyWear: false
    };
  },
  props: {
    prartName: {
      type: String,
      default: ""
    }
  },
  components: {},
  computed: {
    btnType: function() {
      return this.formData.subscribePreference.toString() + this.manWear.toString() + this.ladyWear.toString();
    },
    checkSub: function() {
      return this.$store.state.subscribePreference.toString() + this.$store.state.shoppingPreference.toString();
    }
  },
  watch: {
    btnType: function() {
      this.actionTip = 0;
      if (!this.formData.subscribePreference) {
        if (this.manWear || this.ladyWear) {
          this.actionBtnType = 2;
        } else {
          this.actionBtnType = 0;
        }
      } else {
        this.actionBtnType = 0;
      }
      if(this.originalData == this.formData.subscribePreference.toString() + this.manWear.toString() + this.ladyWear.toString()){
        this.actionBtnType = 2;
      }
    },
    checkSub: function() {
      this.dataInit()
    }
  },
  mounted() {
    console.log(this.$store.state);
    document.title = "订阅偏好" + this.$store.state.titleSuffix;
    this.$gaAction.pageview(document.title, this.$route.path);
    this.dataInit();
    console.log(this.formData)
  },
  methods: {
    changeBtnBg() {
      if (this.actionBtnType == 0) {
        return "";
      }
      if (this.actionBtnType == 1) {
        return "saved";
      }
      if (this.actionBtnType == 2) {
        return "ban";
      }
    },
    dataInit() {
      this.formData.subscribePreference = this.$store.state.subscribePreference;
      if(this.$store.state.shoppingPreference == 0) {
        this.ladyWear = false;
        this.manWear = false;
      }
      if (this.$store.state.shoppingPreference == 1) {
        this.ladyWear = true;
      }
      if (this.$store.state.shoppingPreference == 2) {
        this.manWear = true;
      }
      if (this.$store.state.shoppingPreference == 3) {
        this.ladyWear = true;
        this.manWear = true;
      }
      this.originalData = this.formData.subscribePreference.toString() + this.manWear.toString() + this.ladyWear.toString()
    },
    changeState(val) {
      if (val == 1) {
        this.formData.subscribePreference = !this.formData.subscribePreference;
      }
      if (val == 2) {
        this.ladyWear = !this.ladyWear;
      }
      if (val == 3) {
        this.manWear = !this.manWear;
      }
    },
    save() {
      if (this.actionBtnType == 0) {
        let url = this.$store.state.API.customer.subSet;
        this.formData.shoppingPreference = [];
        if (this.manWear) {
          this.formData.shoppingPreference.push("MANWEAR");
        }
        if (this.ladyWear) {
          this.formData.shoppingPreference.push("LADYWEAR");
        }
        let params = this.formData;
        this.$http.post(url, params,{headers:{"tb_token":this.$store.state.access_token}}).then(res => {
          if (res.status == 200) {
            console.log(res);
            if (res.data.returnCode == "00") {
              this.originalData = this.formData.subscribePreference.toString() + this.manWear.toString() + this.ladyWear.toString();
              var data = res.data.returnData;
              window.localStorage.setItem("userInfo", JSON.stringify(data));
              this.$store.commit("resetUserInfo",data);
              this.actionBtnType = 1;
              if (this.formData.subscribePreference) {
                this.actionTip = 1;
              } else {
                this.actionTip = 2;
              }
            } else {
              this.subModal = false;
              //this.$Message.error(res.data.message);
              this.userExit();
              this.$Message.error({content:"登录已过期，请重新登录",duration:3});
            }
          }
        });
      }
    },
    logData() {
      console.log(this.formData.subscribePreference.toString() + this.manWear.toString() + this.ladyWear.toString())
    }
  },
  beforeRouteLeave(to, from, next) {
    var state_2 = this.$store.state.RefreshAcountNav;
    this.$store.commit("RefreshAcountNav", !state_2);
    next(true);
  },
  created() {}
};
</script>
<style lang="less" scoped>
.user-info-container {
  padding: 1rem;
  .content {
    padding: 1rem 1.2rem;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    text-align: left;
    .email-switch-pc {
      display: block;
    }
    .email-switch-mb {
      display: none;
    }
    .setting-item {
      width: 100%;
      // display: flex;
      .title {
        color: #5c5d5f;
        &.shop {
          //margin-bottom: 2rem;
        }
      }
      .items {
        display: flex;
        margin-bottom: 4rem;
        .item {
          display: flex;
          width: 35%;
          min-width: 23rem;
          margin-top: 1.4rem;
          .label {
            padding-right: 1rem;
          }
          .hint {
            color: #989a95;
          }
          .value{
            line-height: 20px;
          }
        }
      }
    }

    .action {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .save-btn1 {
        width: 50%;
        max-width: 35rem;
        max-height: 3.5rem;
        margin-right: 0;
      }
      .ban {
        cursor: unset;
        background: rgba(229, 229, 229, 1);
        text-decoration: unset !important;
      }
      .saved {
        cursor: unset;
        background: #ffffff;
        border: 1px solid #959595;
        color: #333333;
        text-decoration: unset !important;
      }
      .action-tip {
        margin-right: 24px;
      }
    }
  }
}
@media screen and (max-width: 1024px) {
  //.user-info-container {
  //  padding: 0;
  //  border: none;
  //  .title {
  //    display: none;
  //    &.shop {
  //      display: block;
  //    }
  //  }
  //  .content {
  //    padding: 0rem;
  //    .email-switch-pc {
  //      display: none;
  //    }
  //    .email-switch-mb {
  //      display: block;
  //    }
  //    .email {
  //      flex-direction: column;
  //    }
  //    .action {
  //      .save-btn1 {
  //        width: 100%;
  //        max-width: 100%;
  //      }
  //    }
  //  }
  //}
}
@media screen and (max-width: 768px) {
  .user-info-container {
    .content {
      .action {
        flex-direction: column;
        margin-top: 8rem;
        .save-btn1 {
          width: 100%;
          max-width: 100%;
        }
        .action-tip {
          width: 100%;
          text-align: right;
          margin-bottom: 1.2rem;
          margin-right: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/EmailSetting.vue